window['assessment_tasks#index'] = function () {
  $('input.assessment-checkbox').on('click', function (e) {
    const value = e.target.value
    const checked = e.target.checked
    const provider = e.target.dataset.provider

    if (checked) {
      $.ajax({
        type: 'POST',
        url: 'assessment_tasks',
        data: {
          'assessment_task[key]': value,
          'assessment_task[provider]': provider,
          'assessment_task[title]': e.target.dataset.title
        },
        success: showSaveMessage($(e.target).parents('tr'))
      })
    } else {
      $.ajax({
        type: 'DELETE',
        url: 'assessment_tasks/destroy_by_key',
        data: { key: value, provider },
        success: showSaveMessage($(e.target).parents('tr'))
      })
    }
  })

  function showSaveMessage (tr) {
    $('.save-message', tr).fadeIn(function () {
      setTimeout(() => $('.save-message', tr).fadeOut(), 1000)
    })
  }
}
